module.exports = __webpack_public_path__ + "img/image 44.6414d1ac.png";